// extracted by mini-css-extract-plugin
export default {"root":"gallary_root__utIF5"};